import moment from 'moment'

export default function exportToPrint(elt, report, date) {
  const w = window.open()
  const formattedDate = moment(date).format('YYYY年MM月DD日 (dd)')
  const title = `${report}_${formattedDate}`
  w.document.write(`<html><head><title>${title}</title><style>
table {
  border-collapse: collapse;
  table-layout: auto;
  /*border: 1px solid black;*/
  margin: 36px auto; }
  table tr {
    /*border: 1px solid black;*/ }
  table th, table td {
    /*border: 1px solid black;*/
    vertical-align: top;
    padding: 6px;
    white-space: nowrap;
    font-size: 0.8rem;
    min-width: 128px;
    text-align: left; }
  table th, table td.header {
    background-color: #D8D8D8;
    vertical-align: middle;
    font-weight: normal; }
  table .cell--title {
    font-size: 1.2rem; }
  table .cell--subtitle {
    font-size: 1.0rem; }
  table .cell--bold {
    font-weight: bold; }
  table .cell--center {
    text-align: center; }
  table .cell--right {
    text-align: right; }
  table .cell--middle {
    vertical-align: middle; }
  table .cell--border {
    border: black solid 1px; }
  table .cell--border--up {
    border-top: black solid 1px; }
  table .cell--border--bottom {
    border-bottom: black solid 1px; }
  table .cell--border--left {
    border-left: black solid 1px; }
  table .cell--border--right {
    border-right: black solid 1px; }
  table .cell--border--noup {
    border-top: none; }
  table .cell--border--nobottom {
    border-bottom: none; }
  table .cell--border--noleft {
    border-left: none; }
  table .cell--border--noright {
    border-right: none; }
  table .cell--border--left--dotted {
    border-left: black dotted 1px; }
  table .cell--small {
    min-width: 64px; }
  table .cell--mini {
    min-width: 32px; }
</style></head><body>${elt.outerHTML}</body></html>`);
  w.print()
  w.close()
}
